<template>
  <div class="village-wrapper">
    <div class="village-list" v-for="(item, index) in villageList" :key="index" @click="villageClick(index)">
      <span>{{item.village_name}}</span>
      <img v-if="userId == item.repair_keeper_id" class="select" src="../../assets/images/select.png">
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'village',
  metaInfo: {
    title: '我的小区'
  },
  data () {
    return {
      villageList: [],
      auto_and_back: 0
    }
  },
  computed: {
    ...mapState(['villageName', 'villageId', 'appid', 'openid', 'userId', 'permission', 'wechatRemind', 'locationRange', 'usertel'])
  },
  created () {
    this.getVillageList()
  },
  methods: {
    ...mapMutations(['changeArgs']),
    getVillageList () {
      // 获取小区列表
      this.axios.get('/wechat/index/getUserVillageList/openid/' + this.openid + '/tel/' + this.usertel + '/authorizer_appid/' + this.appid)
        .then((res) => {
          if (res.data.status === 1) {
            this.villageList = res.data.data
            if (this.$route.query.auto_and_back === 1) {
              for (var i = 0; i < this.villageList.length; i++) {
                if (this.villageList[i].village_id == this.$route.query.village_id) {  // eslint-disable-line
                  this.auto_and_back = 1
                  this.villageChange(i)
                  return false
                }
              }
            }
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    villageClick (index) {
      this.$messagebox({
        message: '确定选择该小区吗？',
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: '确定'
      }).then(action => {
        if (action === 'confirm') { // 确认的回调
          this.villageChange(index)
        }
      })
    },
    villageChange (index) {
      var village = this.villageList[index]
      this.changeArgs({
        villageName: village.village_name,
        villageId: village.village_id,
        userId: village.repair_keeper_id,
        permission: village.permission,
        wechatRemind: village.wechat_repair_remind,
        locationRange: village.location_range,
        memberId: village.member_id,
        permissionSign: village.permission_sign
      })
      console.log(this.$route.query.index)
      if (this.auto_and_back === 1) { // 跳过来自动选一下小区而已，切完返回即可
        this.$router.go(-1)
      } else if (this.$route.query.index === 1 || this.$route.query.index === '1') {
        this.$router.push({name: 'Index'})
      } else if (this.$route.query.index === 2 || this.$route.query.index === '2') {
        this.$router.push({name: 'Mine'})
      } else if (this.$route.query.index === 3 || this.$route.query.index === '3') {
        this.$router.push({name: 'RepairCenter'})
      } else if (this.$route.query.index === 4 || this.$route.query.index === '4') {
        this.$router.push({name: 'Material'})
      } else {
        this.$router.push({name: 'Index'})
      }
    }
  }
}
</script>
<style scoped>
.village-wrapper {
  font-size: 14px;
  color: #191919;
}
.village-wrapper .village-list {
  display: flex;
  border-bottom: 1px solid #f1f1f1;
}
.village-wrapper .village-list span{
  padding: 10px 8px;
}
.village-wrapper .village-list span:first-child {
  flex: 1;
}
.select {
  width: 25px;
  height: 25px;
  vertical-align: top;
  padding: 8px 8px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Index/Village.vue